import { render, staticRenderFns } from "./StaffOrders.vue?vue&type=template&id=0d50548a&scoped=true"
import script from "./StaffOrders.vue?vue&type=script&lang=js"
export * from "./StaffOrders.vue?vue&type=script&lang=js"
import style0 from "./StaffOrders.vue?vue&type=style&index=0&id=0d50548a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d50548a",
  null
  
)

export default component.exports